import { render } from "./SideNavbar.vue?vue&type=template&id=56fed2bf"
import script from "./SideNavbar.vue?vue&type=script&lang=js"
export * from "./SideNavbar.vue?vue&type=script&lang=js"
script.render = render

export default script